import { useNavigate } from "react-router-dom"
import { useTranslation } from "@/language"

export function NotFoundPage() {
  const { t } = useTranslation("common")
  const navigate = useNavigate()

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6"
      style={{ backgroundColor: "#020202" }}
    >
      {/* 404 number */}
      <h1
        className="text-[120px] leading-none font-bold tracking-tight mb-4"
        style={{ color: "#f2f0eb" }}
      >
        404
      </h1>

      {/* Message */}
      <p className="text-lg text-center mb-2" style={{ color: "#f2f0eb" }}>
        {t("errors.notFound.title")}
      </p>
      <p className="text-sm text-center max-w-sm mb-8" style={{ color: "#ffffff5e" }}>
        {t("errors.notFound.description")}
      </p>

      {/* Go home button */}
      <button
        onClick={() => navigate("/")}
        className="px-6 py-2.5 rounded-full text-sm font-medium transition-colors"
        style={{
          backgroundColor: "#f2f0eb",
          color: "#020202",
        }}
        onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = "#f2f0ebcc"
        }}
        onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = "#f2f0eb"
        }}
      >
        {t("errors.notFound.goHome")}
      </button>
    </div>
  )
}
